import { ChangeDetectionStrategy, Component, computed, input, output, signal } from '@angular/core';

@Component({
    selector: 'xui-action-disabled',
    templateUrl: './action-disabled.component.html',
    styleUrls: ['./action-disabled.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionDisabledComponent {

    readonly disabledTitle = input('Disabled');
    readonly disabledMessage = input('This functionality is currently disabled');
    readonly buttonClicked = output<void>();
    private readonly overrideMessage = signal<string | null>(null);
    readonly displayDisabledMessage = computed(() => this.overrideMessage() ?? this.disabledMessage());
    active = false;
    visible = false;

    show(message?: string) {
      this.active = true;
      this.overrideMessage.set(message ?? null);
      this.visible = true;
    }

    isVisible(): boolean {
        return this.visible;
    }

    onClick() {
      this.visible = false;
      this.overrideMessage.set(null);
      this.buttonClicked.emit();
    }
}
